<div class="container d-flex flex-column align-items-center">
  <div class="center-text">
    <div class="pb-sm-48-lg-64">
      <app-card-banner></app-card-banner>
    </div>
    <div class="gb-headline1 heavy pb-18">
      <div [innerHTML]="$safeNavigationMigration(pageInformation?.title)"></div>
    </div>
    <div class="gb-headline5 align-items-center center-text pb-24">
      <div
        [innerHTML]="$safeNavigationMigration(pageInformation?.subTitle)"
      ></div>
    </div>
    <div class="gb-body1 center-text pb-sm-24-lg-36">
      <div
        [innerHTML]="$safeNavigationMigration(pageInformation?.subText)"
      ></div>
    </div>
  </div>
  <div class="pb-sm-48-lg-36">
    <div class="header-style">
      <div class="option-style-text">
        <select
          class="header-style--type-select stat-dropdown"
          [(ngModel)]="selectedType"
          (ngModelChange)="filterVehicleList($event)"
          id="car-style"
        >
          <option value="" disabled selected hidden>Vehicle Type</option>
          <option
            *ngFor="let item of modelSelection | keyvalue"
            [value]="item.value"
          >
            {{ item.key }}
          </option>
        </select>
        <svg
          class="dropdown-icon"
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
        >
          <g clip-path="url(#clip0_4867_60935)">
            <path
              d="M9.99988 13.6569L15.6567 19.3137L21.3136 13.6569"
              stroke="#3D3935"
              stroke-width="1.5"
            />
          </g>
          <defs>
            <clipPath id="clip0_4867_60935">
              <rect width="32" height="32" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>
    </div>
  </div>

  <div class="content-container container-fluid">
    <div class="gap-section pb-sm-48-lg-64">
      <app-vehicle-list
        [vehicleList]="chevyListFilter"
        [logo]="chevyLogo"
        [selectedType]="selectedType"
        [viewAll]="viewAllChevy"
        [brand]="listOfBrands[0]"
        [button1]="$safeNavigationMigration(pageInformation?.button1)"
        [button2]="$safeNavigationMigration(pageInformation?.button2)"
        [button1Link]="chevyBtn1Link"
      ></app-vehicle-list>
      <app-vehicle-list
        [vehicleList]="buickListFilter"
        [logo]="buickLogo"
        [selectedType]="selectedType"
        [viewAll]="viewAllBuick"
        [brand]="listOfBrands[1]"
        [button1]="$safeNavigationMigration(pageInformation?.button1)"
        [button2]="$safeNavigationMigration(pageInformation?.button2)"
        [button1Link]="buickBtn1Link"
      ></app-vehicle-list>
      <app-vehicle-list
        [vehicleList]="gmcListFilter"
        [logo]="gmcLogo"
        [selectedType]="selectedType"
        [viewAll]="viewAllGmc"
        [brand]="listOfBrands[2]"
        [button1]="$safeNavigationMigration(pageInformation?.button1)"
        [button2]="$safeNavigationMigration(pageInformation?.button2)"
        [button1Link]="gmcBtn1Link"
      ></app-vehicle-list>
      <app-vehicle-list
        [vehicleList]="cadillacListFilter"
        [logo]="cadillacLogo"
        [selectedType]="selectedType"
        [viewAll]="viewAllCadillac"
        [brand]="listOfBrands[3]"
        [button1]="$safeNavigationMigration(pageInformation?.button1)"
        [button2]="$safeNavigationMigration(pageInformation?.button2)"
        [button1Link]="cadillacBtn1Link"
      ></app-vehicle-list>
    </div>
    <div>
      <app-faq></app-faq>
    </div>
  </div>
</div>
